import React from "react";
import Footer from "../../../components/layout/Footer/Footer";
import {
  SmallText,
  SmallText2,
  Container,
  H1,
  ImgContainer,
  SmallH1,
  TeamContainer,
  BoxContainer,
  LPContainer,
  Photo,
  TextContainer,
  Text1,
  Text12,
  Br,
  LinkedIn,
  SmallText22,
  SmallText23,
  Box2,
  Box21,
  TeamContainerMobile,
  PhotoMobile,
} from "./styles";
import {
  Box,
  BoxText,
  BoxText2,
  BoxTitleN,
  BoxTitleN2,
  BtnW,
  H1W,
  H2W,
  Span,
} from "../../ServicePages/Services1/styles";
import { useNavigation } from "../../../types/Navigates";
import { Boxq, Box2q, Box21q } from "../../ServicePages/Services6/styles";

const Company = () => {
  const { toServices } = useNavigation();

  return (
    <>
      <ImgContainer $img={require("./bg1.png")}>
        <H1>Prohorova Consult – это больше, чем агентство</H1>
        <SmallH1>
          Наша история началась 2021 году. За это время мы помогли решить больше
          1000 карьерных задач, найти более 100 IT талантов и подарить профессию
          IT рекрутера 60 выпускникам.
        </SmallH1>
      </ImgContainer>
      <Container>
        <Text1>Наша миссия</Text1>
        <SmallText>
          Мы уверены в том, что для каждой победы нужна поддержка. Наша команда
          предоставляет бутиковый сервис, который всегда сопровожден личным
          подходом к каждому клиенту.
        </SmallText>
      </Container>
      <TeamContainer $img={require("./bg2.png")} />
      <TeamContainerMobile $img={require("./bgMobile.jpg")} />
      <Container>
        <Text1>
          Мотивируем<Span>на результат</Span>
        </Text1>
        <SmallText>
          Мы построили экосистему, которая помогает решить боли карьеры и
          трудоустройства. Наши клиенты всегда могут рассчитывать на нас и с
          уверенностью смотрят в будущее.
        </SmallText>
        <SmallText>
          Мы специализируемся только на том, в чем обладаем глубокими знаниями и
          опытом. Наша репутация в отрасли — результат многолетней работы и
          успешных проектов.
        </SmallText>
      </Container>
      <LPContainer>
        <Photo $img={require("./LP.png")} />
        <PhotoMobile $img={require("./LPMobile.jpg")} />
        <TextContainer>
          <Text12>
            Любовь <Span>Прохорова</Span>
            <SmallText22>Основательница Prohorova Consult </SmallText22>
            <Br />
            <SmallText2>
              Написала диссертацию по эмоциональному выгоранию в IT
            </SmallText2>
            <SmallText2>Магистр практической психологии и коучинга</SmallText2>
            <SmallText2>Высшее образование в HR-менеджменте и PR</SmallText2>
            <Br />
            <LinkedIn href="https://www.linkedin.com/in/%D0%BB%D1%8E%D0%B1%D0%BE%D0%B2%D1%8C-%D0%BF%D1%80%D0%BE%D1%85%D0%BE%D1%80%D0%BE%D0%B2%D0%B0-755167185/">
              Профиль LinkedIn →
            </LinkedIn>
            <SmallText23>
              Привет! Меня зовут Любовь Прохорова, и я рада, что ты заглянул на
              сайт Prohorova Consult. Давай на "ты"? Мне кажется, так будет
              проще и приятнее общаться.
            </SmallText23>
            <SmallText23>
              Я еще ни разу не пожалела, что ушла из найма и стала помогать
              другим в их развитии. Сложно объяснить, но когда у нас получается
              решить еще один сложный кейс, то я ощущаю мурашки в животе и
              сильную пульсацию в груди – одним словом счастье.
            </SmallText23>
            <SmallText23>
              Убеждена, что именно искренние человеческие отношения лежат в
              основе любого успешного сотрудничества.
            </SmallText23>
            <SmallText23>Добро пожаловать!</SmallText23>
          </Text12>
        </TextContainer>
      </LPContainer>
      <Text1>
        Наши результаты
        <Span>
          говорят
          <br />
          сами за себя
        </Span>
      </Text1>
      <BoxContainer>
        <Boxq>
          <BoxTitleN2>85%</BoxTitleN2>
          <BoxText2>Рекомендуют нас своим знакомым и коллегам</BoxText2>
        </Boxq>
        <Box2q>
          <BoxTitleN2>9/10</BoxTitleN2>
          <BoxText2>Находят работу во время сопровождения</BoxText2>
        </Box2q>
        <Box2q>
          <BoxTitleN2>4+</BoxTitleN2>
          <BoxText2>Года на рынке</BoxText2>
        </Box2q>
        <Box21q>
          <BoxTitleN2>2000+</BoxTitleN2>
          <BoxText2>Клиентов разных стран и индустрий</BoxText2>
        </Box21q>
      </BoxContainer>
      <br />
      <br />
      <ImgContainer $img={require("./bg3.png")}>
        <H1W>
          Развитие карьеры, рост команды и смена профессии начинается здесь
        </H1W>
        <H2W>Мы помогаем открыть свой потенциал и получить работу мечты.</H2W>
        <BtnW href="https://t.me/ProhorovaConsult">Все услуги</BtnW>
      </ImgContainer>
      <br />

      <Footer />
    </>
  );
};
export default Company;
